import { render, staticRenderFns } from "./QueryTigerS.vue?vue&type=template&id=3453d17b&"
import script from "./QueryTigerS.vue?vue&type=script&lang=js&"
export * from "./QueryTigerS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports